/** @format */

import {
  initAgentMasterSessionData,
  initZMasterSessionData,
  initBankAccountSessionData,
  initEconomicConditionMasterSessionData,
  initEconomicDividedSessionData,
  initEconomicSessionData,
  initEntryCheckData,
  initFileSessionData,
  initMerchantSessionData,
  initOperationSessionData,
  initRepresentativeSessionData,
  initReviewContentsDivisionSessionData,
  initShopSessionData,
  initSystemSettingMasterSessionData,
} from "../constance/sessionData";
import { setSession } from "../sessionStorage/sessionStorageMethod";
import { initLoginSessionData, initUserSessionData, initSumFeeSessionData, initEntrySessionData } from "../@types";

//すべてのセッションストレージを初期値で設定
export const setSessionAllData = () => {
  setSession("login", initLoginSessionData);
  setSession("user", initUserSessionData);
  setSession("entry", initEntrySessionData);
  setSession("sum_fee", initSumFeeSessionData);
  setSession("review_contents_division", initReviewContentsDivisionSessionData);
  setSession("agent_master", initAgentMasterSessionData);
  setSession("z_master", initZMasterSessionData);
  setSession("system_setting_master", initSystemSettingMasterSessionData);
  setSession("economic_condition_master", initEconomicConditionMasterSessionData);
  setSession("merchant", initMerchantSessionData);
  setSession("representative", initRepresentativeSessionData);
  setSession("bank_account", initBankAccountSessionData);
  setSession("operation", initOperationSessionData);
  setSession("files", initFileSessionData);
  setSession("shop", initShopSessionData);
  setSession("economic_condition", initEconomicSessionData);
  setSession("economic_devided", initEconomicDividedSessionData);
  setSession("entry_check", initEntryCheckData);
  setSession("entry_infos_count", 0);
};

/**
 * お申込み履歴画面⇒申込選択時利用
 */
export const setSessionDataForLoginFunction = () => {
  setSession("agent_master", initAgentMasterSessionData);
  setSession("sum_fee", initSumFeeSessionData);
  setSession("review_contents_division", initReviewContentsDivisionSessionData);
  setSession("system_setting_master", initSystemSettingMasterSessionData);
  setSession("economic_condition_master", initEconomicConditionMasterSessionData);
  setSession("merchant", initMerchantSessionData);
  setSession("representative", initRepresentativeSessionData);
  setSession("bank_account", initBankAccountSessionData);
  setSession("operation", initOperationSessionData);
  setSession("files", initFileSessionData);
  setSession("shop", initShopSessionData);
  setSession("economic_condition", initEconomicSessionData);
  setSession("economic_devided", initEconomicDividedSessionData);
  setSession("entry_check", initEntryCheckData);
};
